import gql from "graphql-tag";

export const CATEGORY_FOR_SEO = gql`
  query categoryForSEO($id: ID!) {
    category(id: $id) {
      id
      name
      seoTitle
      seoDescription
      slug
      backgroundImage(size: "1080x440") {
        url
      }
    }
    shop {
      name
      domain {
        url
      }
    }
  }
`;
